import { createCanBoundTo } from "@casl/react";

import { ability } from "permissions";

export default createCanBoundTo(ability);
